<div class="route-options-container" [hidden]="routeDetails">
    <div class="header" fxLayout="row" fxLayoutAlign="space-between center">
        <span i18n>Rutas sugeridas</span>
        <span fxLayoutAlign="center center">
            
            <span class="delete-route" (click)="deleteEmitter.emit(false)"><img src="assets/img/close-2.svg" i18n-alt alt="Borrar ruta"></span>
        </span>
    </div>

    <div *ngIf="routes.length === 0 && inrixData === null" class="no-route">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
    
    <div  *ngFor="let route of routes; let i = index" fxLayout="column" fxLayoutAlign="center space-between" fxLayoutGap="10px" class="route"
     (click)="directionsService.setActiveRoute(i); selectRoute(route);" (mouseenter)="directionsService.setPreviewRoute(i)" (mouseleave)="directionsService.setPreviewRoute(-1)"
     [class.selected]="route === selectedRoute">
        <div fxLayout="row" fxLayoutAlign="space-between start">
            <span class="route-title" i18n>Por {{route.summary}}</span>
            <span class="route-detail" (click)="routeDetails = true; selectedRouteIndex = i; cdRef.detectChanges()" i18n>Detalle de la ruta</span>
        </div>
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
            <span class="info-chip" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5px">
                <span><img src="assets/img/distanceIcon.svg" alt="Icona cotxe"></span><span>{{getDistance(route)}}</span>
            </span>
            <span class="info-chip" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5px">
                <span><img src="assets/img/timeIcon.svg" alt="Icona temps"></span><span>{{getDuration(route)}}</span>
            </span>
            <span class="info-chip" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5px">
                <span><img src="assets/img/fuelIcon.svg" alt="Icona gasolina"></span><span>{{getFuel(route) | number}}€</span>
            </span>
        </div>
    </div>

    <div *ngIf="inrixFlag && inrixData !== null" fxLayout="column" fxLayoutAlign="center space-between" fxLayoutGap="10px" class="route">
        <div fxLayout="row" fxLayoutAlign="space-between start">
            <span class="route-title">{{convertString(inrixData.summary)}}</span>
            <span class="opcions-fuel" (click)="navigateToPrint()"><img src="assets/img/imprimirIcon.svg" alt="Imprimir"></span>
        </div>
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
            <span class="info-chip" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5px">
                <span><img src="assets/img/distanceIcon.svg" alt="Icona cotxe"></span><span>{{inrixData.distance}}</span>
            </span>
            <span class="info-chip" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5px">
                <span><img src="assets/img/timeIcon.svg" alt="Icona temps"></span><span>{{inrixData.duration}}</span>
            </span>
            <span class="info-chip" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5px">
                <span><img src="assets/img/fuelIcon.svg" alt="Icona gasolina"></span><span>{{inrixData.fuel}}</span>
            </span>
        </div>
    </div>
    
</div>

<div [hidden]="!routeNotFoundFlag" class="no-route" i18n>
    No se ha encontrado ninguna ruta. Introduce una dirección válida.
</div>


<div class="route-details-container" [hidden]="!routeDetails" *ngIf="routes.length > 0">
    <div class="header" fxLayout="row" fxLayoutAlign="space-between center">
        <span class="go-back" (click)="routeDetails = false;cdRef.detectChanges()" fxLayout="row" fxLayoutGap="5px"><img src="assets/img/backArrow.svg" alt="Tornar als resultats"><span i18n>Volver a resultados</span></span>
        <span class="opcions-fuel" (click)="navigateToPrint()"><img src="assets/img/imprimirIcon.svg" alt="Imprimir"></span>
    </div>
    <div id="route-steps-container" *ngIf="routes[selectedRouteIndex].legs">
        <div *ngFor="let leg of routes[selectedRouteIndex].legs; let iLeg = index">
            <div class="route-leg-title" fxLayout="row" fxLayoutAlign="start start">
                <div fxFlex="20%"><img src="{{urlImg + iconNames[iLeg]}}" width="30px" alt=""></div>
                <div fxLayout="column" fxLayoutAlign="start start">
                    <div><b>{{leg.start_address}}</b></div>
                    <div i18n>Aproximadamente <b>{{leg.duration.text}}</b></div>
                </div>
            </div>
            <div class="route-step" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px" *ngFor="let step of leg.steps; let iStep =index" (click)="selectStep(step);">
                <div fxFlex="10%">
                    {{iStep + 1 }}.
                </div>
                <div fxFlex="75%" [innerHTML]="step.instructions">
                    
                </div>
                <div fxFlex="15%" class="distance" fxLayoutGap="5px" fxLayout="column" fxLayoutAlign="center center" fxFlexAlign="center">
                    <div>
                        {{step.distance.text}}
                    </div> 
                    <div *ngIf="step.maneuver !== '' && step.maneuver !== 'ramp'">
                        <img class="maneuver-icon" src="assets/img/maneuvers/{{step.maneuver}}.png">
                    </div>
                </div>
        
            </div>
        </div>
        <div class="route-leg-title" fxLayout="row" fxLayoutAlign="start start">
            <div fxFlex="20%"><img src="{{urlImg + iconNames[routes[selectedRouteIndex].legs.length]}}" alt=""></div>
            <div fxLayout="column" fxLayoutAlign="start start">
                <div><b>{{routes[selectedRouteIndex].legs[routes[selectedRouteIndex].legs.length-1].end_address}}</b></div>  
            </div>
        </div>
    </div>
    
    
</div>